import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-d-r',
  templateUrl: './three-d-r.component.html',
  styleUrls: ['./three-d-r.component.scss']
})
export class ThreeDRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
